<template> 
  <div> 
    <div class="page-title d-flex flex-column me-3 mt-3"> 
        <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">Closing Operations</h1>  
        <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
            <li class="breadcrumb-item text-gray-600">
                <a href="#" class="text-gray-600 text-hover-primary">
                    <router-link :to="{ name: 'Home' }">Home</router-link>
                </a>
            </li>  
            <li class="breadcrumb-item text-primary">Accounting</li> 
            <li class="breadcrumb-item text-primary">Accounting Transaction</li>
            <li class="breadcrumb-item text-gray-600">Closing Operations</li>    
        </ul> 
    </div>  
    <div class="content flex-row-fluid mt-4" id="kt_content">  
        <div class="row">       
            <div class="col-lg-12">
                <div class="card mb-6">
                    <div class="card-header border-0 pt-6">
                        <div class="card-title">
                        </div>
                        <div class="card-toolbar">
                            <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                                <Popper hover placement="top">
                                    <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                        <i class="bi bi-eraser-fill fs-4"> </i>
                                    </button>
                                    <template #content>
                                        <span class="text-gray-800"> Reset All Criterias </span>
                                    </template>
                                </Popper>
                                <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on">
                                    <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                                    <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    <span v-if="!this.isListProgressing"> List Balances </span> 
                                    <span class="indicator-progress" v-if="this.isListProgressing">
                                        Getting Data... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span> 
                                </button>                        
                            </div>
                            <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                                <div class="fw-bolder me-5">
                                <span class="me-2" data-kt-customer-table-select="selected_count"></span>Selected</div>
                                <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">Delete Selected</button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row p-3">
                            <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2 bg-light">
                                <div class="fv-row mb-7 row">    
                                    <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>Accounting Period</span> 
                                        </label>   
                                        <Select2 v-model="form.period_id" :options="accountingYears" :settings="{ width: '100%' }" @select="onChangeAccountYear($event)" :disabled="this.lists.length > 0"/>  
                                    </div>
                                    <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>Balance Type</span>
                                        </label>
                                        <Select2 v-model="form.report_type" :options="reportTypeList" :settings="{width: '100%'}"  :disabled="this.lists.length > 0"/>
                                    </div>
                                     <div class="col-lg">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            <span>Balance Date</span>
                                        </label>
                                        <Datepicker textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.balance_date" 
                                        inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" 
                                        :disabled="this.lists.length > 0" 
                                        @update:modelValue="onChangeBalanceDate()"></Datepicker>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div>
                                <!-- Tercih edilen Balance Type'a göre hesap bakiyeleri gelecek -->
                                <!-- Comparative Balance General görüntüsü gelecek . Level 1'ler olmayacak. Background renkleri aynı olack (Accounting Transaction gibi) --> 
                                <!-- Kayıt Kuralı: Balance = 0 olacak -->

                                <!-- Opening için geçerli -->
                                <!-- Kapanıştan alıyorsa -> Önceki dönemde kapatılan kayıtları bul, onları aç. Hep ters kayıt yapılır. Balance debit ise, credit kaydı yapılacak. Sıfırlanması için -->
                                <!-- Accounting Balances -> gördüğü bakiyenin aynısını kaydedecek. Paralel kayıt  -->

                                <!-- Closing -->
                                <!-- Her zaman ters kayıt yapılır -->

                                <!-- Önceki dönemdeki muhasebe planı bu dönemde yoksa kırmızı ile işaretlenecek ve editlenebilecek (Yeni plan kodunu seçeceğiz listeden) -->
                                <DxDataGrid :show-borders="true" 
                                            :data-source="lists" 
                                            :allow-column-reordering="true"  
                                            :allow-column-resizing="true" 
                                            :column-auto-width="true" 
                                            :row-alternatin-enabled="true"
                                            :hover-state-enabled="true" 
                                            :show-row-lines="true"
                                            @row-prepared="onRowPrepared"
                                            @exporting="this.$onExporting($event , 'Closing-Operation-List')"> 

                                        <DxFilterRow :visible="true"/>
                                        <DxHeaderFilter :visible="true"/>
                                        <DxGroupPanel :visible="true"/>      
                                        <DxExport :enabled="true" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                        <DxPaging :page-size="1000"/>
                                        <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="true" :show-info="true" :show-navigation-buttons="true"/> 
                                        <DxSearchPanel :visible="true"/>  
                                        <DxScrolling
                                            mode="virtual"
                                            row-rendering-mode="virtual"
                                            
                                        />
                                        <DxColumn data-field="l2_account_code" caption="Account Code" header-cell-template="l2-account-code-header" :width="120" cell-template="l2_account_code-cell-template"/> 
                                        <DxColumn data-field="l2_account_name" caption="Account Name" header-cell-template="l2-account-name-header" cell-template="l2_account_name-cell-template"/> 
                                        <DxColumn data-field="account_code" caption="Account Code" header-cell-template="account-code-header" :width="120" cell-template="account_code-cell-template"/> 
                                        <DxColumn data-field="account_name" caption="Account Name" header-cell-template="account-name-header" cell-template="account_name-cell-template"/> 
                                        <DxColumn data-field="balance" caption="Balance" alignment="right" cell-template="balance-cell-template"/>
                                        <DxColumn data-field="debit_credit" caption="Debit / Credit" cell-template="debit_credit-cell-template" header-cell-template="debit-credit-header"/>

                                        <template #l2-account-code-header>
                                            <div>Account Code</div><div>(Level 2)</div>
                                        </template>
                                        <template #l2-account-name-header>
                                            <div>Account Name</div><div>(Level 2)</div>
                                        </template>
                                        <template #account-code-header>
                                            <div>Account</div><div>Code</div>
                                        </template>
                                        <template #account-name-header>
                                            <div>Account</div><div>Name</div>
                                        </template>
                                        <template #new-account-code-header>
                                            <div>New</div><div>Account Code</div>
                                        </template>
                                        <template #debit-credit-header>
                                            <div>Debit</div><div>Credit</div>
                                        </template>

                                        <template #l2_account_code-cell-template="{ data }"> 
                                             <span class="text-hover-primary text-gray-900">
                                                {{ data.data.l2_account_code }}
                                             </span>
                                        </template>
                                        <template #l2_account_name-cell-template="{ data }"> 
                                             <span class="text-hover-primary text-gray-900">
                                                {{ data.data.l2_account_name }}
                                             </span>
                                        </template>
                                        <template #account_code-cell-template="{ data }"> 
                                             <span class="text-hover-primary text-gray-900">
                                                {{ data.data.account_code }}
                                             </span>
                                        </template>
                                        <template #account_name-cell-template="{ data }"> 
                                            <span class="text-hover-primary text-gray-900">
                                                {{ data.data.account_name }}
                                            </span>
                                        </template>
                                        <template #balance-cell-template="{ data }"> 
                                             <span class="text-hover-primary text-gray-900">
                                                {{ data.data.balance }}
                                             </span>
                                        </template>
                                        <template #debit_credit-cell-template="{ data }"> 
                                             <span class="text-hover-primary text-gray-900">
                                                {{ data.data.debit_credit }}
                                             </span>
                                        </template> 
                                </DxDataGrid>
                            </div>
                        </div> 
                    </div>
                </div> 
            </div>
            <div class="col-lg-12">
                <div class="card card-xxl-stretch mb-6">
                    <div class="card-body">
                        <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2">
                            <div class="fv-row mb-7 row">                      
                                <div class="col-lg-2">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>Voucher Date</span>
                                    </label>
                                    <Datepicker textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.record_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'"></Datepicker>
                                </div>
                                <div class="col-lg-8">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>Description</span>
                                    </label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" name="discount" v-model="form.description">
                                        <div class="input-group-append" v-if="this.descriptionTypeList.length > 0">
                                            <div class="dropdown dropup">
                                                <button class="btn btn-secondary border border-gray-300 dropdown-toggle rounded-start-0" type="button" @click="this.isOpenDescriptionDropdown = !this.isOpenDescriptionDropdown;">
                                                    <i class="bi bi-plus-lg fs-5 fw-boldest"> </i>
                                                </button>
                                                <div class="dropdown-menu px-3 dropdown-menu-end" data-bs-popper="true" :class="{ 'show': this.isOpenDescriptionDropdown }">
                                                    <ul class="mh-250px mb-0 overflow-scroll list-unstyled"> 
                                                        <li v-for="(item, index) in descriptionTypeList" v-bind:key="item">
                                                            <a class="dropdown-item cursor-pointer p-2 mw-500px" @click="onSelectDescription(item)"
                                                                :class="{'text-success': this.form.description == item.description && item.description !== ''}">
                                                                <i class="bi bi-dash fw-boldest" v-if="this.form.description !== item.description"> </i> 
                                                                <i class="bi bi-check-lg fw-boldest text-success" v-if="this.form.description == item.description && item.description !== ''"> </i>
                                                                {{item.text}}  
                                                            </a>
                                                            <div class="separator separator-dashed my-1" v-if="index !== descriptionTypeList.length - 1"></div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        <span>Save Provision For Balance</span>
                                    </label>
                                    <Select2 v-model="this.form.save_provision" :options="this.isSaveBalanceProvisionList" :settings="{ width: '100%' }"/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card card-xxl-stretch mb-6">
                    <div class="card-body">
                        <div class="d-grid gap-2"> 
                            <button class="btn btn-success btn-lg" type="button" @click="saveClosingVoucher()" data-kt-indicator="on" :disabled="!this.lists.length > 0"> 
                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                </svg>
                                </span>  
                                <strong v-if="!this.isSaving"> Create Closing Voucher </strong> 
                                <span class="indicator-progress" v-if="this.isSaving">
                                    Saving Transaction. Please wait... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
  </div>  
</template>

<script>
import axios from 'axios' 
import moment from 'moment';
  

import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxScrolling } from 'devextreme-vue/data-grid';
 
export default {
    name: "ClosingOperationsList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxScrolling
    },
	data() {
        return {
            searchbar: '',
            isOpenDescriptionDropdown: false,
            isListProgressing: false,
            isOpenActionsDropdown: false, 
            summary: {},
            lists: [],
            accountingYearList: [],
            accountingYearSelection: null,
            accountingYears: [],
            form:  {
                record_date: moment(), 
                balance_date: moment(),
                report_type: 1,
                period_id: null,
                periodSelection: {},
                save_provision: 0
            },
            reportTypeList: [
                { id: 1, text: 'Accounting Balances'}
            ],
            isSaveBalanceProvisionList: [
                { id: 0, text: 'No'},
                { id: 1, text: 'Yes'}
            ],
            isAccountingYearLoading: false,
            descriptionTypeList: [],
            temp_session_id: null,
            planList: [],
            accountSelection: null,
            newAccountSelection: null
        };
  },
  computed: {  
    searchableList() {
      return this.lists.slice((this.page - 1) * this.page_size, this.page * this.page_size);
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    previewOnlyDate(){
        return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
                }
            }
        },
    getReportTypeValue(){
        return (value)=>{
            if (value) {
                return this.reportTypes.find(p => { 
                    return p.id == value;
                }).text; 
            }
        } 
    },
    getPeriodMonthValue(){
        return (value)=>{
            if (value) {
                var period = this.periodList.find(p => { 
                return p.id == value && p.id != '-1';
            }); 
            if(period){
                return period.text;
            }
            else{
                return null;
            }
            }
        } 
    },
    checkIfNewAccountSelected(){
        return this.newAccountSelection == null ? false : true;
    }
  },
  methods: { 
    getData() {
        this.lists = [];
        this.planList = [];
        this.accountSelection = null;
        this.newAccountSelection = null;
        const params = {
            session_id: this.$getUser().session_id,
            balance_date: moment(this.form.balance_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            period_id: this.form.period_id
        };
        axios.post('/api/Closing/GetListClosing', params, {'Content-Type': 'application/json'})
        .then((response) => {  
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                this.lists = response.data.data; 
                this.temp_session_id = response.data.temp_session_id; 
            }
            else{
                this.lists = [];
            }
            this.$Progress.finish();
        })
        .catch(function (error) {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    getAccountingYears(){
        this.isAccountingYearLoading = true;
        this.companyAccountingPeriods = [];
        const queryParameter = {
            id: this.$getSessionStorage("selected_company").id,
            session_id: this.$getUser().session_id,
        };
        axios.post('/api/Accounts/GetCompanyAccountingYears', queryParameter, {'Content-Type': 'application/json'})
        .then((response) => {   
            this.accountingYears = response.data; 
            this.accountingYears.forEach((period) => {
                if(period.id == this.$getSessionStorage("selected_company").activeYear){
                    this.form.period_id = period.id;
                    this.form['periodSelection'] = period; 
                    this.form.record_date = moment(this.form['periodSelection'].end_date); 
                    this.form.balance_date = moment(this.form['periodSelection'].end_date); 
                } 
            }); 
            this.getDescriptions(); 
            setTimeout(() => {
                this.isAccountingYearLoading = false;
            }, 1000); 
        })
        .catch(function (error) {
            this.isAccountingYearLoading = false;
            console.error(error);
        }); 
    },
    onChangeAccountYear(e){
        this.form['periodSelection'] = e;
        this.form.record_date = this.form['periodSelection'].end_date; 
        this.form.balance_date = this.form['periodSelection'].end_date; 
    },
    setCriteriasToDefault() {   
        this.lists = [];
        this.newAccountSelection = null;
        this.accountSelection = null;
        this.form = {
            record_date: moment().subtract((parseInt(this.$getSessionStorage("selected_company").list_date_range)), 'days'), 
            report_type: 1, 
            period_id: null,
            periodSelection: {},
            save_provision: 0,
            balance_date: moment()
        };
        this.getAccountingYears();
    },
    saveClosingVoucher(){
        this.$swal.fire({
                title: "You are about to save the Closing Voucher. Are you sure about this?",
                confirmButtonColor: "#50cd89",
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: "CONFIRM",
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) {  
                        this.isSaving = true;
                        const params = {
                            session_id: this.$getUser().session_id,
                            balance_date: moment(this.form.balance_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                            period_id: this.form.period_id,
                            save_provision: this.form.save_provision,
                            description: this.form.description,
                            record_date: moment(this.form.record_date).format('YYYY-MM-DD[T]HH:mm:ss'),
                            tmp_session_id: this.temp_session_id
                        };
                        axios.post('/api/Closing/Create', params, {'Content-Type': 'application/json'})
                        .then((response) => { 
                            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                                this.$swal("Success", "Closing Voucher saved successfully..!", 'success');  
                                this.setCriteriasToDefault();
                            }
                            this.isSaving = false;
                            this.$Progress.finish();
                        })
                        .catch(function (error) {
                            console.error(error); 
                            this.$Progress.fail();
                        });
                }
            }); 
    },
    getDescriptions() {
        this.isOpenDescriptionDropdown = false;
        const params = {
            session_id: this.$getUser().session_id,
            description_location: 15, // Closing Operations
            location_detail: 0,
            account_type: 0,
            sales_type: 0
        };
        axios.post('/api/Closing/GetDescriptionTypes', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.descriptionTypeList = response.data;
            this.descriptionTypeList.forEach(element => {
                if (element.type_id == 2) {
                    this.form.description = element.description;
                }
            });
            this.$Progress.finish();
        })
        .catch(function (error) {
            console.error(error); 
            this.$Progress.fail();
        });
    },
    onSelectDescription(item) {
        this.form.description = item.description;
        this.isOpenDescriptionDropdown = false;
    },
    openSelectionModal(item){ 
        const queryParameter = {
            plan_level: 3,
            company_id: this.$getSessionStorage("selected_company").id,
            accounting_period_id: this.form.period_id,
            session_id: this.$getUser().session_id,
        };  
        axios.post('/api/CompanyAccountingPlans/GetAccountingPlanByLevel', queryParameter, {'Content-Type': 'application/json'}) 
        .then((response) => {
            this.planList = response.data;
            this.accountSelection = item;
        })
        .catch(function () {
            this.$Progress.finish();
        });
    }, 
    onChangeBalanceDate(){
        this.form.record_date = moment(this.form.balance_date);
    },
    onRowPrepared(e){
        if(e.rowType === 'data') {
            if(e.data.not_exists == 1) { 
                e.rowElement.classList.add('bg-danger');  
                e.rowElement.classList.add('bg-opacity-10');  
            }  
        } 
    }
  },
  created() {        
    this.temp_session_id = null;
    this.getAccountingYears();
    this.$removeSessionStorage('record_id');
  },
  mounted(){
    try{ 
        this.form.record_date = moment().subtract((parseInt(this.$getSessionStorage("selected_company").list_date_range)), 'days');
    }
    catch(Err){ console.error(Err);}
  }
}; 
</script>